import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import useIsMobile from '../../hooks/useIsMobile';

const NetWorthSummary = ({ data }) => {
  const isMobile = useIsMobile();
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Net Worth</Text>
      
      <View style={styles.content}>
        <View style={[styles.mainRow, isMobile && styles.mainRowMobile]}>
          <Text style={[styles.totalAmount, isMobile && styles.totalAmountMobile]}>
            {formatCurrency(data.total)}
          </Text>
          <Text style={[
            styles.changeAmount,
            isMobile && styles.changeAmountMobile,
            data.change >= 0 ? styles.positiveChange : styles.negativeChange
          ]}>
            {data.change >= 0 ? '+' : ''}{formatCurrency(data.change)} ({data.changePercentage}%)
          </Text>
        </View>

        <View style={styles.separator} />

        <View style={[styles.breakdown, isMobile && styles.breakdownMobile]}>
          <View style={styles.breakdownItem}>
            <Text style={styles.breakdownLabel}>Assets</Text>
            <Text style={[styles.breakdownValue, isMobile && styles.breakdownValueMobile]}>{formatCurrency(data.assets)}</Text>
          </View>
          <View style={styles.breakdownItem}>
            <Text style={styles.breakdownLabel}>Liabilities</Text>
            <Text style={[styles.breakdownValue, isMobile && styles.breakdownValueMobile]}>{formatCurrency(data.liabilities)}</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 24,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
    elevation: 2,
  },
  title: {
    fontSize: 18,
    fontWeight: '500',
    color: '#111827',
    marginBottom: 16,
  },
  content: {
    gap: 16,
  },
  mainRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  mainRowMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
  },
  totalAmount: {
    fontSize: 28,
    fontWeight: '600',
    color: '#111827',
  },
  totalAmountMobile: {
    fontSize: 32,
    textAlign: 'left',
  },
  changeAmount: {
    fontSize: 14,
    fontWeight: '500',
  },
  changeAmountMobile: {
    fontSize: 16,
  },
  positiveChange: {
    color: '#059669',
  },
  negativeChange: {
    color: '#DC2626',
  },
  separator: {
    height: 1,
    backgroundColor: '#F3F4F6',
    marginVertical: 8,
  },
  breakdown: {
    flexDirection: 'row',
    gap: 16,
  },
  breakdownMobile: {
    flexDirection: 'column',
    gap: 12,
  },
  breakdownItem: {
    flex: 1,
  },
  breakdownLabel: {
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 4,
  },
  breakdownValue: {
    fontSize: 18,
    fontWeight: '500',
    color: '#111827',
  },
  breakdownValueMobile: {
    fontSize: 20,
  },
});

export default NetWorthSummary; 